import { Exception } from '@web/common';

export class AuthTokenNotFoundException extends Exception {
  public constructor(message = 'The auth token not found.') {
    super(message);
  }
}
